import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { TextField } from "@material-ui/core";
import moment from "moment";
import Swal from "sweetalert2";
import BetterBox from "../../../components/BetterBox";
import BetterSelect from "../../../components/BetterSelect";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { getDashboard } from "../../../crud/dashboard.crud";
import { getSimpleList } from "../../../crud/closer.crud";
import BetterCircularProgress from "../../../components/BetterCircularProgress";
 

export default class DashboardPage extends Component {
    

    render() {
        return (
            <BetterCircularProgress loading={false}>
                 
            </BetterCircularProgress>
        );
    }
}